import { Box, Typography, useTheme, alpha } from "@mui/material";

interface FieldConfidence {
    value: number;
}

interface FormConfidenceIndicatorProps {
    fieldConfidence?: Record<string, FieldConfidence>;
    maxItems?: number;
}

const FormConfidenceIndicator = ({
    fieldConfidence,
    maxItems = 5,
}: FormConfidenceIndicatorProps) => {
    const theme = useTheme();

    if (!fieldConfidence || Object.keys(fieldConfidence).length === 0) {
        return null;
    }

    return (
        <Box sx={{
            mt: 3,
            p: 2,
            backgroundColor: theme.palette.mode === 'dark'
                ? alpha(theme.palette.primary.main, 0.1)
                : alpha(theme.palette.grey[100], 0.9),
            borderRadius: 1,
            border: `1px solid ${theme.palette.divider}`,
        }}
        >
            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
                Field Confidence Scores
            </Typography>
            {Object.entries(fieldConfidence).slice(0, maxItems).map(([field, confidence]) => (
                <Box key={field} sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                    <Typography variant="caption">{field}:</Typography>
                    <Typography variant="caption" color={confidence.value > 0.8 ? 'success.main' : 'warning.main'}>
                        {(confidence.value * 100).toFixed(1)}%
                    </Typography>
                </Box>
            ))}
        </Box>
    );
};

export default FormConfidenceIndicator;
